import { ScheduleDepartmentService } from '../../components/services';
import { TaskForCalendarAssignment } from '../../types/interfaces';

export const generateMockTasks = (
  employeeIds: string[],
  selectedDateFilter: Date | null
): Record<string, TaskForCalendarAssignment[]> => {
  const monthStart = selectedDateFilter
    ? new Date(
        selectedDateFilter.getFullYear(),
        selectedDateFilter.getMonth(),
        1
      )
    : new Date(2025, 8, 1);

  const sharedTask1: TaskForCalendarAssignment = {
    id: 84604902,
    taskType: { id: '1', label: 'Экстренный вызов' },
    creationTime: '2025-09-04T09:45:00',
    factStart: '2025-09-01T09:30:00',
    planStart: '2025-09-01T09:30:00',
    factFinish: '2025-09-05T09:30:00',
    finish: '2025-09-05T09:30:00',
    planFinish: '2025-09-08T01:45:00',
    isClosed: false,
    personId: 1
  };

  const sharedTask2: TaskForCalendarAssignment = {
    id: 84604903,
    taskType: { id: '1', label: 'Модернизация сети' },
    creationTime: '2025-09-04T09:49:00',
    planStart: '2025-09-02T09:30:00',
    factStart: '2025-09-02T09:30:00',
    factFinish: '2025-09-07T07:30:00',
    finish: '2025-09-07T09:48:00',
    planFinish: '2025-09-07T09:48:00',
    isClosed: false,
    personId: 20581
  };

  const sharedTask3: TaskForCalendarAssignment = {
    id: 84604919,
    taskType: { id: '1', label: 'Модернизация сети' },
    creationTime: '2025-09-04T09:45:00',
    planStart: '2025-09-05T09:30:00',
    factStart: '2025-09-05T09:30:00',
    factFinish: '2025-09-07T09:30:00',
    finish: '2025-09-07T09:30:00',
    planFinish: '2025-09-08T01:45:00',
    isClosed: false,
    personId: 1
  };

  const mockTasks: Record<string, TaskForCalendarAssignment[]> = {};

  if (employeeIds[0]) {
    mockTasks[20581] = [sharedTask2];
  }

  if (employeeIds[1]) {
    mockTasks[10295] = [
      {
        ...sharedTask2,
        personId: 10295
      }
    ];
  }

  if (employeeIds[2]) {
    mockTasks[1] = [sharedTask1, sharedTask3];
  }

  if (employeeIds[3]) {
    mockTasks[10527] = [{ ...sharedTask1, personId: 10527 }];
  }

  return mockTasks;
};

export const mockGetTasksByDepartment = async (departmentId: number) => {
  console.log(
    'Mock getTasksByDepartment called with departmentId:',
    departmentId
  );
  const diagramResponse = await ScheduleDepartmentService.getDiagram(
    departmentId,
    {}
  );
  const employeeIds = diagramResponse.data.value.employees
    .slice(0, 4)
    .map((emp) => emp.id.toString());
  return {
    data: {
      value: generateMockTasks(employeeIds, new Date(2025, 8, 1))
    }
  };
};

// Mock function for getDiagram
export const mockGetDiagram = async () => {
  console.log('Mock getDiagram called');
  return {
    data: {
      value: {
        employees: [
          { id: 71781048, name: '1 1 ', personnelNumber: '1' },
          { id: 71780874, name: '1 1 1', personnelNumber: '1' },
          { id: 71781062, name: '1 1 1', personnelNumber: '1' }
        ]
      }
    }
  };
};
